import React from 'react';
import { motion } from 'framer-motion/dist/framer-motion';
import { isMobileOrTabletBrowser } from '../../utils/device';

interface FadedComponentProps {
  children: React.ReactNode;
  className?: string;
  animatedStyle?: object;
}

export default function FadedComponent({ children, className = '', animatedStyle = {} }: FadedComponentProps) {
  return !isMobileOrTabletBrowser() ? (
    <>{children}</>
  ) : (
    <motion.div
      className={className}
      style={animatedStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.2 } }}
    >
      {children}
    </motion.div>
  );
}
